<template><div><h2 id="usage" tabindex="-1" class="d-docsite--header-2">Usage <a class="header-anchor d-link d-docsite--link d-link" href="#usage" aria-hidden="true">#</a></h2>
<code-example source-code='&lt;div class=&quot;d-p-200 d-bgc-moderate d-code--sm d-bar-300 d-c-all-scroll&quot;&gt;d-c-all-scroll&lt;/div&gt;
&lt;div class=&quot;d-p-200 d-bgc-moderate d-code--sm d-bar-300 d-c-auto&quot;&gt;d-c-auto&lt;/div&gt;
&lt;div class=&quot;d-p-200 d-bgc-moderate d-code--sm d-bar-300 d-c-col-resize&quot;&gt;d-c-col-resize&lt;/div&gt;
&lt;div class=&quot;d-p-200 d-bgc-moderate d-code--sm d-bar-300 d-c-copy&quot;&gt;d-c-copy&lt;/div&gt;
&lt;div class=&quot;d-p-200 d-bgc-moderate d-code--sm d-bar-300 d-c-crosshair&quot;&gt;d-c-crosshair&lt;/div&gt;
&lt;div class=&quot;d-p-200 d-bgc-moderate d-code--sm d-bar-300 d-c-default&quot;&gt;d-c-default&lt;/div&gt;
&lt;div class=&quot;d-p-200 d-bgc-moderate d-code--sm d-bar-300 d-c-grab&quot;&gt;d-c-grab&lt;/div&gt;
&lt;div class=&quot;d-p-200 d-bgc-moderate d-code--sm d-bar-300 d-c-grabbing&quot;&gt;d-c-grabbing&lt;/div&gt;
&lt;div class=&quot;d-p-200 d-bgc-moderate d-code--sm d-bar-300 d-c-help&quot;&gt;d-c-help&lt;/div&gt;
&lt;div class=&quot;d-p-200 d-bgc-moderate d-code--sm d-bar-300 d-c-menu&quot;&gt;d-c-menu&lt;/div&gt;
&lt;div class=&quot;d-p-200 d-bgc-moderate d-code--sm d-bar-300 d-c-move&quot;&gt;d-c-move&lt;/div&gt;
&lt;div class=&quot;d-p-200 d-bgc-moderate d-code--sm d-bar-300 d-c-none&quot;&gt;d-c-none&lt;/div&gt;
&lt;div class=&quot;d-p-200 d-bgc-moderate d-code--sm d-bar-300 d-c-not-allowed&quot;&gt;d-c-not-allowed&lt;/div&gt;
&lt;div class=&quot;d-p-200 d-bgc-moderate d-code--sm d-bar-300 d-c-pointer&quot;&gt;d-c-pointer&lt;/div&gt;
&lt;div class=&quot;d-p-200 d-bgc-moderate d-code--sm d-bar-300 d-c-progress&quot;&gt;d-c-progress&lt;/div&gt;
&lt;div class=&quot;d-p-200 d-bgc-moderate d-code--sm d-bar-300 d-c-row-resize&quot;&gt;d-c-row-resize&lt;/div&gt;
&lt;div class=&quot;d-p-200 d-bgc-moderate d-code--sm d-bar-300 d-c-text&quot;&gt;d-c-text&lt;/div&gt;
&lt;div class=&quot;d-p-200 d-bgc-moderate d-code--sm d-bar-300 d-c-wait&quot;&gt;d-c-wait&lt;/div&gt;
&lt;div class=&quot;d-p-200 d-bgc-moderate d-code--sm d-bar-300 d-c-zoom-in&quot;&gt;d-c-zoom-in&lt;/div&gt;
&lt;div class=&quot;d-p-200 d-bgc-moderate d-code--sm d-bar-300 d-c-zoom-out&quot;&gt;d-c-zoom-out&lt;/div&gt;'>
<dt-stack data-demo-wrapper direction="row" gap="100" class="d-fw-wrap d-w100p d-bar-400 d-plc-center">
  <div class="d-p-200 d-bgc-moderate d-code--sm d-bar-300 d-c-all-scroll">d-c-all-scroll</div>
  <div class="d-p-200 d-bgc-moderate d-code--sm d-bar-300 d-c-auto">d-c-auto</div>
  <div class="d-p-200 d-bgc-moderate d-code--sm d-bar-300 d-c-col-resize">d-c-col-resize</div>
  <div class="d-p-200 d-bgc-moderate d-code--sm d-bar-300 d-c-copy">d-c-copy</div>
  <div class="d-p-200 d-bgc-moderate d-code--sm d-bar-300 d-c-crosshair">d-c-crosshair</div>
  <div class="d-p-200 d-bgc-moderate d-code--sm d-bar-300 d-c-default">d-c-default</div>
  <div class="d-p-200 d-bgc-moderate d-code--sm d-bar-300 d-c-grab">d-c-grab</div>
  <div class="d-p-200 d-bgc-moderate d-code--sm d-bar-300 d-c-grabbing">d-c-grabbing</div>
  <div class="d-p-200 d-bgc-moderate d-code--sm d-bar-300 d-c-help">d-c-help</div>
  <div class="d-p-200 d-bgc-moderate d-code--sm d-bar-300 d-c-menu">d-c-menu</div>
  <div class="d-p-200 d-bgc-moderate d-code--sm d-bar-300 d-c-move">d-c-move</div>
  <div class="d-p-200 d-bgc-moderate d-code--sm d-bar-300 d-c-none">d-c-none</div>
  <div class="d-p-200 d-bgc-moderate d-code--sm d-bar-300 d-c-not-allowed">d-c-not-allowed</div>
  <div class="d-p-200 d-bgc-moderate d-code--sm d-bar-300 d-c-pointer">d-c-pointer</div>
  <div class="d-p-200 d-bgc-moderate d-code--sm d-bar-300 d-c-progress">d-c-progress</div>
  <div class="d-p-200 d-bgc-moderate d-code--sm d-bar-300 d-c-row-resize">d-c-row-resize</div>
  <div class="d-p-200 d-bgc-moderate d-code--sm d-bar-300 d-c-text">d-c-text</div>
  <div class="d-p-200 d-bgc-moderate d-code--sm d-bar-300 d-c-wait">d-c-wait</div>
  <div class="d-p-200 d-bgc-moderate d-code--sm d-bar-300 d-c-zoom-in">d-c-zoom-in</div>
  <div class="d-p-200 d-bgc-moderate d-code--sm d-bar-300 d-c-zoom-out">d-c-zoom-out</div>
</dt-stack>
</code-example>
<h2 id="classes" tabindex="-1" class="d-docsite--header-2">Classes <a class="header-anchor d-link d-docsite--link d-link" href="#classes" aria-hidden="true">#</a></h2>
<utility-class-table>
  <template #content>
    <tbody>
      <tr v-for="{ class: className, output } in cursor">
        <th scope="row" class="d-code--sm d-docsite-code">.{{ className }}</th>
        <td class="d-code--sm">{{ output }}</td>
      </tr>
    </tbody>
  </template>
</utility-class-table>
</div></template>


<script setup>
  import { cursor } from '@data/interactivity.json';
</script>